import { useQuery } from '@pinia/colada';

import applicationsService from '../services/applications.service';

export function getApplicationBundlesQueryKey() {
  return ['application-bundles'];
}

export function useApplicationBundlesQuery() {
  return useQuery({
    key: () => getApplicationBundlesQueryKey(),
    query: () => applicationsService.getBundles(),
  });
}
